export default function GlobalStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Source+Serif+4:ital,wght@0,400;0,600;0,700;1,400&family=DM+Mono:wght@400;500&display=swap');
      *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
      html,body,#root{height:100%}
      ::-webkit-scrollbar{width:4px}
      ::-webkit-scrollbar-track{background:#0A0806}
      ::-webkit-scrollbar-thumb{background:#3A3020;border-radius:2px}
      @keyframes fadeUp    {from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
      @keyframes fadeIn    {from{opacity:0}to{opacity:1}}
      @keyframes spin      {to{transform:rotate(360deg)}}
      @keyframes wave      {0%,100%{height:3px}50%{height:14px}}
      @keyframes slideDown {from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)}}
      @keyframes pulse     {0%,100%{opacity:1}50%{opacity:.45}}
      .msg-in    {animation:fadeUp    0.3s ease forwards}
      .fade-in   {animation:fadeIn    0.6s ease both}
      .fade-up   {animation:fadeUp    0.8s ease both}
      .slide-down{animation:slideDown 0.25s ease forwards}
      button{cursor:pointer;outline:none;border:none;background:none}
      input{font-family:'Source Serif 4',serif}
    `}</style>
  );
}
